(function(){
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- smooth scroll (Lenis) ---- */
  let lenis=null;
  if(!reduce && window.Lenis){
    lenis = new Lenis({lerp:.09,wheelMultiplier:1});
    function raf(t){lenis.raf(t);requestAnimationFrame(raf);}
    requestAnimationFrame(raf);
    if(window.ScrollTrigger){lenis.on('scroll',ScrollTrigger.update);}
  }
  // anchor links via lenis
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click',e=>{
      const id=a.getAttribute('href');
      if(id.length>1){const el=document.querySelector(id);
        if(el){e.preventDefault(); lenis?lenis.scrollTo(el,{offset:-70}):el.scrollIntoView({behavior:'smooth'}); closeMenu();}}
    });
  });

  /* ---- header scroll state + hide on scroll down ---- */
  const masthead=document.getElementById('masthead');
  let lastY=0;
  function onScroll(){
    const y=window.scrollY;
    masthead.classList.toggle('scrolled', y>60);
    if(y>lastY && y>560){masthead.classList.add('hide');}else{masthead.classList.remove('hide');}
    lastY=y;
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();

  /* ---- reveal on scroll ---- */
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(en=>{ if(en.isIntersecting){en.target.classList.add('is-in'); io.unobserve(en.target);} });
  },{threshold:.14, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('[data-reveal]').forEach(el=>io.observe(el));

  /* ---- hero headline reveal (CSS-transition driven; robust vs rAF throttling) ---- */
  var heroEl=document.querySelector('.hero');
  setTimeout(function(){ heroEl.classList.add('reveal'); },120);

  /* ---- parallax (GSAP ScrollTrigger) ---- */
  if(!reduce && window.gsap && window.ScrollTrigger){
    gsap.registerPlugin(ScrollTrigger);
    gsap.to('#heroImg',{yPercent:12,ease:'none',scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}});
    gsap.fromTo('#atmosImg',{yPercent:-8},{yPercent:8,ease:'none',scrollTrigger:{trigger:'.atmos',start:'top bottom',end:'bottom top',scrub:true}});
    gsap.fromTo('#bottleImg',{yPercent:-5},{yPercent:5,ease:'none',scrollTrigger:{trigger:'.product',start:'top bottom',end:'bottom top',scrub:true}});
  }

  /* ---- magnetic buttons ---- */
  if(!reduce && window.matchMedia('(pointer:fine)').matches){
    document.querySelectorAll('.btn').forEach(btn=>{
      btn.addEventListener('mousemove',e=>{
        const r=btn.getBoundingClientRect();
        gsap.to(btn,{x:(e.clientX-r.left-r.width/2)*.28,y:(e.clientY-r.top-r.height/2)*.34,duration:.5,ease:'power3.out'});
      });
      btn.addEventListener('mouseleave',()=>gsap.to(btn,{x:0,y:0,duration:.6,ease:'elastic.out(1,.5)'}));
    });
  }

  /* ---- mobile nav ---- */
  const mn=document.getElementById('mobileNav');
  function openMenu(){mn.classList.add('open'); if(lenis)lenis.stop(); document.body.style.overflow='hidden';}
  function closeMenu(){mn.classList.remove('open'); if(lenis)lenis.start(); document.body.style.overflow='';}
  document.getElementById('burger').addEventListener('click',openMenu);
  document.getElementById('mnClose').addEventListener('click',closeMenu);

  /* Das Newsletter-Formular ist ein echtes Shopify-Kundenformular.
     Es darf nicht per JavaScript abgefangen werden, sonst wird nichts gespeichert. */
})();